import React from 'react';

import './item.scss';

const Item: React.FC<{ label: string; info: string }> = ({ label, info }) => {
    return (
        <div className={'contact-info_information-item'}>
            <span className='contact-info_information-item_label'>{label}</span>
            <span className='contact-info_information-item_info'>{info}</span>
        </div>
    );
};

export default Item;
